var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartPie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V12C11.25 12.4142 11.5858 12.75 12 12.75H21C21.4142 12.75 21.75 12.4142 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM12.75 11.25V3.78363C16.7079 4.14029 19.8597 7.29215 20.2164 11.25H12.75ZM9.28156 4.20815C9.67266 4.07171 9.87911 3.64406 9.74267 3.25296C9.60624 2.86187 9.17859 2.65542 8.78749 2.79185C8.40209 2.9263 8.02776 3.08422 7.66623 3.26389C4.45765 4.85841 2.25 8.17071 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C16.2464 21.75 19.8569 19.0358 21.195 15.2499C21.333 14.8594 21.1284 14.4309 20.7378 14.2929C20.3473 14.1548 19.9188 14.3595 19.7808 14.7501C18.6478 17.9554 15.5909 20.25 12 20.25C7.44365 20.25 3.75 16.5564 3.75 12C3.75 8.76186 5.61547 5.95804 8.33377 4.60716C8.63948 4.45524 8.95589 4.32176 9.28156 4.20815Z",
    fill: "#4262FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPie);
export default __webpack_public_path__ + "static/media/Chart_Pie.905900a34566c897de63823e862dc59e.svg";
export { ForwardRef as ReactComponent };